<template>
    <div class="page">
        
        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Alterar senha</div>
                <div class="right">
                    <a style="opacity: 0" class="link panel-open" data-panel="left">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z" fill="black"></path>
                            <path d="M14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1045 10.8954 22 12 22C13.1046 22 14 21.1045 14 20Z" fill="black"></path>
                            <path d="M14 4C14 2.89544 13.1046 2.00001 12 2.00001C10.8954 2.00001 10 2.89544 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4Z" fill="black"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>        
        <div class="page-content">

            <div class="container hidden-xs hidden-md">
                <h2>Alterar senha</h2>
            </div>

            <div class="">
                <form  method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                    <div class="list" style="margin-top: 16px">
                        <ul class="row">
                                                           
                            <li class="item-content item-input col-100 mt-10">
                                <div class="item-inner">
                                    <div class="item-title item-label">Senha atual</div>
                                    <div class="item-input-wrap">
                                        <input type="password" placeholder="Informe sua senha atual.." v-model="form.senhaAtual" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100 mt-10">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nova senha</div>
                                    <div class="item-input-wrap">
                                        <input type="password" placeholder="Informe a nova senha.." v-model="form.senha" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100 mt-10">
                                <div class="item-inner">
                                    <div class="item-title item-label">Confirme a nova senha</div>
                                    <div class="item-input-wrap">
                                        <input type="password" placeholder="Informe a nova senha.." v-model="form.senhaConfirmacao" class="form-control"/>
                                    </div>
                                </div>
                            </li>                                                        
                        </ul>
                    </div>
                    <div class="block">

                        <button type="submit" class="link external button-large button button-fill">
                            <i class="las la-save"></i>
                            Salvar
                        </button>
                    </div>
                </form>

            </div>
        </div>
        
    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'AlterarSenha',
    components: {
        'Toolbar': Toolbar,
        'Top': Top,
    },          
    data () {
        var self                    = this;
        return {
            loading: {
                "submit":           false,
            },
            form: {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "senhaAtual":       "",
                "senha":            "",
                "senhaConfirmacao": ""
            }            
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            
            axios.put("api/alterar-senha.php", self.form)
            .then(response => {
                self.loading.submit = false;
                console.log("ok", response)
                loading.hide();
                alert(response.data.message);
                self.$root.go("Inicio");
             
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        }
    }, 
    created: function() {
    },
    mounted: function() {
       
        loading.hide();
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/AlterarSenha.vue